module.exports = __webpack_public_path__ + "img/elephant.37434c95.jpg";